module.exports = __webpack_public_path__ + "static/media/m_eyeshape_downturned_grey.97d0e13b.png";